import { useTranslation } from "@equiem/web-ng-lib";
import { PageTitle } from "@equiem/web-ng-lib";
import { NextPage } from "next";
import React from "react";
import { GeneralLayout } from "../components/layout/GeneralLayout";
import { LegalContent } from "../components/legal/LegalContent";
import { withAppContexts } from "../contexts/withAppContexts";
import { PageViewPageType } from "../generated/gateway-client";

export const PrivacyPage: NextPage = ({}) => {
  const { t } = useTranslation();

  return (
    <GeneralLayout>
      <PageTitle>{t("main.privacyPolicy")}</PageTitle>
      <h1 className="text-site">{t("main.privacyPolicy")}</h1>
      <LegalContent type="privacy" />
    </GeneralLayout>
  );
};

export default withAppContexts(PrivacyPage, {
  requireAuth: false,
  skipMetrics: false,
  skipLegalCheck: true,
  pageTitle: "Privacy Policy",
  pageViewType: PageViewPageType.Static,
});
